import * as React from 'react';
import {
    SimpleForm,
    TextInput,
    Toolbar,
    SaveButton,
    DeleteButton,
    ToolbarClasses,
    useTranslate,
    useGetList,
    AutocompleteArrayInput,
    AutocompleteInput,
    useCreateSuggestionContext,
    required,
    NumberInput,
    useRecordContext,
    useCreate,
    useUpdate,
    SelectInput,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';
import dataProvider from '../dataProvider';

import {
    Box,
    Grid,
    Typography,
    Divider,
    Tooltip,
    IconButton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { PackageMetadataSpec, Module } from '../dataProvider';
import InfoIcon from '@mui/icons-material/Info';

const SectionTitle = ({ label }: { label: string }) => {
    const translate = useTranslate();

    return (
        <Typography variant="h6" gutterBottom>
            {translate(label as string)}
        </Typography>
    );
};

export enum Mode {
    Create,
    Edit,
}

export const DataSetForm = ({ mode }: { mode: Mode }) => {
    const record = useRecordContext();
    const [create] = useCreate();
    const [update] = useUpdate();
    const navigate = useNavigate();

    const postSave = async (data: any) => {
        if (record) {
            data.name = record.name;
            data.package = record.package;
        }
        const id = record ? record.id : data.metadata.name;
        const userName = localStorage.getItem('userName');
        if (!userName) {
            throw new Error('User ID not found');
        }
        try {
            if (mode === Mode.Edit) {
                await update('datasets', { id: id, data });
            } else {
                await create('datasets', { data });
            }
            navigate(`/datasets/${id}/show`);
        } catch (error) {
            console.error('Request failed', error);
        }
    };

    const PostCreateToolbar = () => (
        <Toolbar>
            <div className={ToolbarClasses.defaultToolbar}>
                <SaveButton
                    label="save"
                    transform={data => ({ ...data, notify: true })}
                    type="button"
                />
                <DeleteButton />
            </div>

            {/*<SaveButton*/}
            {/*    label="save"*/}
            {/*    transform={data => ({ ...data, notify: true })}*/}
            {/*    type="button"*/}
            {/*/>*/}
            {/*<DeleteButton />*/}
        </Toolbar>
    );

    return (
        <SimpleForm
            sx={{ maxWidth: 500 }}
            defaultValues={{}}
            // toolbar={<PostCreateToolbar/>}
            onSubmit={postSave}
        >
            <SectionTitle
                label={
                    mode === Mode.Create
                        ? 'resources.datasets.form.createTitle'
                        : 'resources.datasets.form.editTitle'
                }
            />
            <TextInput
                source="metadata.name"
                label="resources.datasets.form.name"
                isRequired={true}
                validate={[
                    required(),
                    (value: string) => {
                        if (!/^[a-zA-Z0-9_-]{1,20}$/.test(value)) {
                            return 'resources.datasets.form.name.invalid';
                        }
                        return undefined;
                    },
                ]}
                disabled={mode === Mode.Edit}
            />
            <SelectInput
                source="spec.type"
                label="resources.datasets.form.type"
                choices={[{ id: 'topic', name: 'Topic' }]}
                validate={required()}
                defaultValue="topic"
            />
            <SelectInput
                source="spec.catalog"
                label="resources.datasets.form.catalog"
                choices={[{ id: 'pulsar', name: 'Pulsar' }]}
                validate={required()}
                defaultValue="pulsar"
            />
        </SimpleForm>
    );
};
